// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.allpage .title{
    color: #4895d1;
    text-decoration: none;
}
.allpage .activeinactive{
    text-align: -webkit-center;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Site_Pages/AllPages.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B","sourcesContent":[".allpage .title{\n    color: #4895d1;\n    text-decoration: none;\n}\n.allpage .activeinactive{\n    text-align: -webkit-center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
